import type { CheckInResult, MembershipStatus } from '@techsofit/api-types';
import type { ConfirmOptions } from '@techsofit/ui';
import { checkInMember } from './gymApi';
import { hasGymAccess } from './membership';

type Confirm = (opts: ConfirmOptions) => Promise<boolean>;

/**
 * Staff check-in. Members without gym access must be confirmed ("Check in anyway")
 * before the override is sent to the API. Returns the result (with streak) or null if cancelled.
 */
export async function staffCheckIn(
  member: { id: string; fullName: string; status: MembershipStatus },
  confirm: Confirm,
): Promise<CheckInResult | null> {
  const override = !hasGymAccess(member.status);
  if (override) {
    const why =
      member.status === 'NEVER_PAID'
        ? `${member.fullName} hasn't paid for gym access.`
        : `${member.fullName}'s gym access has ended.`;
    const ok = await confirm({
      title: 'No gym access',
      description: `${why} Check them in anyway?`,
      confirmLabel: 'Check in anyway',
    });
    if (!ok) return null;
  }
  return checkInMember(member.id, override);
}
